import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { BASE_URL } from "../../env.js";
import { Link } from "react-router-dom";
import "./UserDashboard.css";
import { First } from "react-bootstrap/esm/PageItem";
const ChartComponent = () => {
	const [wSignup, setWstudent] = useState([]);
	const [showData, setShowData] = useState(false);
	const [tStudent, setTstudent] = useState(0);
	const [tSignup, setTsignup] = useState(0);
	const [wwSignup, setWwstudent] = useState(0);
	const [aStudent, setAstudent] = useState(0);
	const [firstMonth, setFirstMonth] = useState(0);
	const [months, setMonths] = useState([
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	]);
	const [graph, setGraph] = useState("604800000");
	const [week, setWeek] = useState({
		1: [],
		2: [],
		3: [],
		4: [],
		5: [],
		6: [],
		7: [],
		8: [],
	});
	const [weeks, setWeeks] = useState({
		1: [],
		2: [],
		3: [],
		4: [],
		5: [],
		6: [],
	});
	const [month, setMonth] = useState({
		1: [],
		2: [],
		3: [],
		4: [],
		5: [],
		6: [],
		7: [],
	});
	const [days, setDays] = useState([]);
	const [monthData, setMonthData] = useState([]);
	const [HalfYearData, setHalfYearData] = useState([]);

	useEffect(() => {
		if (HalfYearData?.data) {
			//sorting the array according to the date
			HalfYearData?.data.sort((a, b) => {
				return new Date(a.signUp_date) - new Date(b.signUp_date);
			});
			//setting the first date of the week
			let firstDate = new Date(HalfYearData.data[0].signUp_date);
			setFirstMonth(firstDate.getMonth());
			firstDate.setDate(firstDate.getDate() + 30); // add 30 day to date

			let i = 1;
			HalfYearData?.data.map((a) => {
				let someDate = new Date(a.signUp_date);
				if (firstDate >= someDate) {
					month[i].push(a);
				} else {
					i++;
					month[i].push(a);
					firstDate.setDate(firstDate.getDate() + 30); // add 30 day to date;
				}
			});
			console.log(weeks);
			setShowData(true);
		}
	}, [HalfYearData]);
	const renderChart = () => {
		if (graph == "604800000") {
			return (
				<>
					<Chart
						width={"700px"}
						height={"400px"}
						chartType="AreaChart"
						loader={<div>Loading Chart</div>}
						data={[
							["Day", "Signup"],

							[days[1], week["2"].length],
							[days[2], week["3"].length],
							[days[3], week["4"].length],
							[days[4], week["5"].length],
							[days[5], week["6"].length],
							[days[6], week["7"].length],
							[days[0], week["8"].length],
						]}
						options={{
							title: "No. Of Signups",
							hAxis: {
								title: "Days",
								titleTextStyle: { color: "#333" },
							},
							vAxis: { title: "No. of Signups", minValue: 0 },
							// For the legend to fit, we make the chart area smaller
							chartArea: { width: "80%", height: "70%" },
							// lineWidth: 25
						}}
						// For tests
						rootProps={{ "data-testid": "1" }}
					/>
				</>
			);
		} else if (graph == "2592000000") {
			return (
				<>
					<Chart
						width={"700px"}
						height={"400px"}
						chartType="AreaChart"
						loader={<div>Loading Chart</div>}
						data={[
							["Day", "Signup"],
							["Week 1", weeks["1"].length],
							["Week 2", weeks["2"].length],
							["Week 3", weeks["3"].length],
							["Week 4", weeks["4"].length],
							["Week 5", weeks["5"].length],
						]}
						options={{
							title: "No. Of Signups",
							hAxis: {
								title: "Weeks",
								titleTextStyle: { color: "#333" },
							},
							vAxis: { title: "No. of Signups", minValue: 0 },
							// For the legend to fit, we make the chart area smaller
							chartArea: { width: "80%", height: "70%" },
							// lineWidth: 25
						}}
						// For tests
						rootProps={{ "data-testid": "1" }}
					/>
				</>
			);
		} else {
			return (
				<>
					<Chart
						width={"700px"}
						height={"400px"}
						chartType="AreaChart"
						loader={<div>Loading Chart</div>}
						data={[
							["Month", "Signup"],
							[`${months[firstMonth]}`, month["1"].length],
							[`${months[firstMonth + 1]}`, month["2"].length],
							[`${months[firstMonth + 2]}`, month["3"].length],
							[`${months[firstMonth + 3]}`, month["4"].length],
							[`${months[firstMonth + 4]}`, month["5"].length],
							[`${months[firstMonth + 5]}`, month["5"].length],
						]}
						options={{
							title: "No. Of Signups",
							hAxis: {
								title: "Month",
								titleTextStyle: { color: "#333" },
							},
							vAxis: { title: "No. of Signups", minValue: 0 },
							// For the legend to fit, we make the chart area smaller
							chartArea: { width: "80%", height: "70%" },
							// lineWidth: 25
						}}
						// For tests
						rootProps={{ "data-testid": "1" }}
					/>
				</>
			);
		}
	};

	useEffect(() => {
		for (let i = 0; i < 7; i++) {
			let todayDate = new Date();
			todayDate.setDate(todayDate.getDate() + i);
			switch (todayDate.getDay()) {
				case 0:
					setDays((p) => [...p, "Sunday"]);
					break;
				case 1:
					setDays((p) => [...p, "Monday"]);
					break;
				case 2:
					setDays((p) => [...p, "Tuesday"]);
					break;
				case 3:
					setDays((p) => [...p, "Wednesday"]);
					break;
				case 4:
					setDays((p) => [...p, "Thursday"]);
					break;
				case 5:
					setDays((p) => [...p, "Friday"]);
					break;
				case 6:
					setDays((p) => [...p, "Saturday"]);
			}
		}
	}, []);

	useEffect(() => {
		if (firstMonth > 12) {
			firstMonth = firstMonth % 12;
		}
	}, [firstMonth]);

	useEffect(async () => {
		await fetch(BASE_URL + `/signupWeek?date=604800000`, {
			method: "GET",
			headers: { "content-type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				setWstudent(data);
				setWwstudent(data);
			});
		await fetch(BASE_URL + `/signupWeek?date=2592000000`, {
			method: "GET",
			headers: { "content-type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				setMonthData(data);
				console.log("Month Data", data);
			});
		await fetch(BASE_URL + `/signupWeek?date=15811200000`, {
			method: "GET",
			headers: { "content-type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				setHalfYearData(data);
				console.log("6 Month Data", data);
			});
	}, []);

	useEffect(() => {
		if (wSignup?.data) {
			//sorting the array according to the date
			wSignup?.data.sort((a, b) => {
				return new Date(a.signUp_date) - new Date(b.signUp_date);
			});
			//setting the first date of the week
			let firstDate = new Date(wSignup.data[0].signUp_date).getDate();
			let i = 1;
			wSignup?.data.map((a) => {
				let someDate = new Date(a.signUp_date).getDate();
				if (firstDate == someDate) {
					week[i].push(a);
				} else {
					i++;
					week[i].push(a);
					firstDate = someDate;
				}
			});
			console.log(week);
			setShowData(true);
		}
	}, [wSignup]);

	useEffect(() => {
		if (monthData?.data) {
			//sorting the array according to the date
			monthData?.data.sort((a, b) => {
				return new Date(a.signUp_date) - new Date(b.signUp_date);
			});
			//setting the first date of the week
			let firstDate = new Date(monthData.data[0].signUp_date);
			firstDate.setDate(firstDate.getDate() + 7); // add 7 day to date
			console.log("FIRSTDATA", firstDate);
			let i = 1;
			monthData?.data.map((a) => {
				let someDate = new Date(a.signUp_date);
				if (firstDate >= someDate) {
					weeks[i].push(a);
				} else {
					i++;
					weeks[i].push(a);
					firstDate.setDate(firstDate.getDate() + 7); // add 7 day to date;
				}
			});
			console.log(weeks);
			setShowData(true);
		}
	}, [monthData]);

	useEffect(async () => {
		await fetch(BASE_URL + "/getAllUsers", {
			method: "GET",
			headers: { "content-type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				setTstudent(data);
			});
		await fetch(BASE_URL + "/signupToday", {
			method: "GET",
			headers: { "content-type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				setTsignup(data);
			});
		await fetch(BASE_URL + "/activeUsers", {
			method: "GET",
			headers: { "content-type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				setAstudent(data);
			});
	}, []);

	return (
		<div>
			<div className="row">
				<div className="col-md-6">
					{!showData ? (
						<h4 className="my-5 text-center">Loading Chart</h4>
					) : (
						renderChart()
					)}
				</div>

				<div className="col-md-6">
					<h4 className="my-5 text-center">Choose the time period</h4>
					<div class="form-check">
						<input
							class="form-check-input"
							type="radio"
							name="time"
							id="7"
							value="604800000"
							onChange={(e) => {
								setGraph(e.target.value);
							}}
						/>
						<label class="form-check-label" for="7">
							7 Days
						</label>
					</div>
					<div class="form-check">
						<input
							class="form-check-input"
							type="radio"
							name="time"
							id="1"
							value="2592000000"
							onChange={(e) => {
								setGraph(e.target.value);
							}}
						/>
						<label class="form-check-label" for="1">
							1 Month
						</label>
					</div>
					<div class="form-check">
						<input
							class="form-check-input"
							type="radio"
							name="time"
							id="6"
							value="15811200000"
							onChange={(e) => {
								setGraph(e.target.value);
							}}
						/>
						<label class="form-check-label" for="6">
							6 Month
						</label>
					</div>
				</div>
			</div>
			<div class="container">
				<div class="row">
					<div class="col-lg-3 col-sm-6">
						<div class="card-box bg-blue">
							<div class="inner">
								<h3>
									{tStudent == 0
										? "Loading..."
										: tStudent?.count}
								</h3>
								<p> Total Students </p>
							</div>
							<div class="icon">
								<i
									class="fa fa-graduation-cap"
									aria-hidden="true"
								></i>
							</div>
							<Link
								class="card-box-footer"
								to={{
									pathname: "/dashboard/user/TotalStudents",
									state: {
										page: "Total Students",
										data: tStudent,
									},
								}}
							>
								View More
								<i class="fa fa-arrow-circle-right"></i>
							</Link>
						</div>
					</div>

					<div class="col-lg-3 col-sm-6">
						<div class="card-box bg-green">
							<div class="inner">
								<h3>
									{tSignup == 0
										? "Loading..."
										: tSignup?.count}
								</h3>
								<p> Students Signup today </p>
							</div>
							<div class="icon">
								<i class="fa fa-money" aria-hidden="true"></i>
							</div>
							<Link
								class="card-box-footer"
								to={{
									pathname: "/dashboard/user/TotalSignups",
									state: {
										page: "Students Signup today ",
										data: tSignup,
									},
								}}
							>
								View More
								<i class="fa fa-arrow-circle-right"></i>
							</Link>
						</div>
					</div>
					<div class="col-lg-3 col-sm-6">
						<div class="card-box bg-orange">
							<div class="inner">
								<h3>
									{wwSignup == 0
										? "Loading..."
										: wwSignup?.count}
								</h3>
								<p> Students Signedup this week </p>
							</div>
							<div class="icon">
								<i
									class="fa fa-user-plus"
									aria-hidden="true"
								></i>
							</div>
							<Link
								class="card-box-footer"
								to={{
									pathname: "/dashboard/user/weeklysignups",
									state: {
										page: "Weekly Signups",
										data: wSignup,
									},
								}}
							>
								View More
								<i class="fa fa-arrow-circle-right"></i>
							</Link>
						</div>
					</div>

					<div class="col-lg-3 col-sm-6">
						<div class="card-box bg-red">
							<div class="inner">
								<h3>
									{aStudent == 0
										? "Loading..."
										: aStudent?.count}
								</h3>
								<p> Active Students </p>
							</div>
							<div class="icon">
								<i
									class="fa fa-user-plus"
									aria-hidden="true"
								></i>
							</div>
							<Link
								class="card-box-footer"
								to={{
									pathname: "/dashboard/user/activestudents",
									state: {
										page: "Active Students",
										data: aStudent,
									},
								}}
							>
								View More
								<i class="fa fa-arrow-circle-right"></i>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ChartComponent;
